import { useEffect, useState } from 'react';

import { MILLISECONDS_PER_SECOND } from '../../constants';
import { EVV_QR_SCAN_TIMEOUT_SECONDS } from '../constants';

import type { UseEvvQrCountdownResult } from './types';

export function useEvvQrCountdown(open: boolean): UseEvvQrCountdownResult {
  const [remainingSeconds, setRemainingSeconds] = useState(EVV_QR_SCAN_TIMEOUT_SECONDS);

  useEffect(() => {
    if (!open) return;

    setRemainingSeconds(EVV_QR_SCAN_TIMEOUT_SECONDS);
    // Count down from a deadline so throttled background-tab timers cannot slow the countdown.
    const deadline = Date.now() + EVV_QR_SCAN_TIMEOUT_SECONDS * MILLISECONDS_PER_SECOND;
    const intervalId = window.setInterval(() => {
      const seconds = Math.max(Math.ceil((deadline - Date.now()) / MILLISECONDS_PER_SECOND), 0);
      setRemainingSeconds(seconds);
      if (!seconds) window.clearInterval(intervalId);
    }, MILLISECONDS_PER_SECOND);

    return () => window.clearInterval(intervalId);
  }, [open]);

  return { remainingSeconds, expired: remainingSeconds === 0 };
}
